import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import axios from 'axios'
import VueAxios from 'vue-axios'
import vuetify from './plugins/vuetify';

Vue.use(VueAxios, axios)

Vue.config.productionTip = false

axios.defaults.baseURL = 'https://jupiterstyle.ar/wp-json/';

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
